<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'admin.download.show.download_information'|translate">
      <app-classic-box #classicForm [classicBox]="classicBox" [data]="lastValue"
                       (changeForm)="enableButton($event)"></app-classic-box>
    </app-card>
  </div>
</div>

<div class="row" *ngIf="isEdit">
  <div class="col-md-12">
    <app-card [title]="('admin.download.show.files'|translate)  + ' (' + downloadFiles.length + ')'">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{'doctrine.file.name'|translate}}</th>
            <th>{{'doctrine.file.file_name'|translate}}</th>
            <th>{{'doctrine.file.size'|translate}}</th>
            <th>{{'doctrine.file.position'|translate}}</th>
            <th>{{'global.actions'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let file of downloadFiles; let i=index">
            <td>{{file.name}}</td>
            <td>{{file.image.filename}}</td>
            <td>{{convertSize(file.image.fileSize)}}</td>
            <td><input class="form-control" type="number" (blur)="positionChange(file.id,file.position)"
                       [name]="'position'+i" [(ngModel)]="file.position" style="max-width: 60px"/></td>
            <td>
              <a class="btn btn-lg btn-primary btn-icon ripple light ms-1" (click)="showAddFileModal(file)">
                <i class="fa fa-pencil"></i>
              </a>
              <a class="btn btn-lg btn-primary btn-icon ripple light ms-1"
                 (click)="showDeleteModal(file.id, file.name)">
                <i class="fa fa-remove"></i>
              </a>
            <td>
          </tr>
          </tbody>
        </table>
      </div>
      <button type="button" class="btn btn-simple ripple me-2 btn-primary light" (click)="addDownload()">
        <span class="feather icon-plus"></span> {{'global.add'|translate}}
      </button>
    </app-card>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
      <div class="card-block pull-right">
        <button (click)="submitItem(false)" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
        <button [disabled]="!enableSave" (click)="submitItem(true)" class="btn btn-primary ripple light"
                type="button">{{(isEdit ? 'global.actions.save' : 'global.add') | translate}}</button>
      </div>
    </div>
  </div>
</div>

<app-modal-basic #addFileModal [dialogClass]="'modal-md'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{(isFileEdit ? 'global.soft_edit_title' : 'global.soft_add_title') | translate:{entity: 'file'} }}
    </h4>
    <button type="button" class="close basic-close" (click)="cancelUpload()" [disabled]="isUploading">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form novalidate #addFileForm="ngForm">
      <div class="form-row row">
        <div class="form-group col-md-12">
          <label for="name">{{"doctrine.download_files.name" | translate}}   <span class="star">*</span></label>
          <input required name="name"
                 #fileName="ngModel"
                 id="name"
                 class="form-control"
                 [(ngModel)]="downloadFile.name">
          <span class="form-bar"></span>
          <div class="messages text-danger"
               *ngIf="fileName.invalid && fileName.touched && fileName.errors?.required">{{'errors.required'|translate}}</div>
        </div>
      </div>
      <div class="row">
        <!-- Loading Style -->
        <div style="height: 40px;" class="preloader3 loader-block mx-auto" *ngIf="isUploading">
          <div class="circ1 loader-success"></div>
          <div class="circ2 loader-success"></div>
          <div class="circ3 loader-success"></div>
        </div>
      </div>
      <div class="row">
        <div [ngClass]="{'d-none':imageFileName}" class="form-group col-md-12">
          <label for="uploaderFile">{{"doctrine.download_files.file" | translate}}   <span class="star">*</span></label>
          <label class="custom-file">
            <input type="file" #uploadEl ng2FileSelect [uploader]="uploader" class="custom-file-input" id="uploaderFile"
                   required>
            <span class="custom-file-control-upload"
                  *ngIf="uploader.queue.length==0">{{"global.upload"|translate}}</span>
            <span class="custom-file-control-upload"
                  *ngIf="uploader.queue.length > 0 || isFileEdit">{{"global.change"|translate}}</span>
            <span
              class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
          </label>
        </div>
        <div class="col-sm-9 pt-4" *ngIf="imageFileName">
          {{imageFileName}}
        </div>
        <div *ngIf="imageFileName" class="col-sm-1 pt-4">
          <button (click)="changeImage($event)"
                  class="btn btn-primary waves-effect waves-light" [disabled]="isUploading">{{'global.change'|translate}}</button>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="cancelUpload()" [disabled]="isUploading">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="addFile()"
            [disabled]="!addFileForm.valid || isUploading||(uploader.queue.length <= 0 && !imageFileName)">
      {{(isFileEdit ? 'global.actions.save' : 'global.add') | translate}}
    </button>
  </div>
</app-modal-basic>

<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'file'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}} : <span [innerHTML]="downloadFileName"></span></p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="delete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>
